import React, { useState } from 'react';
import { FaAddressBook, FaHome, FaCaretDown, FaFileSignature, FaUserEdit } from 'react-icons/fa';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import { useAuth } from '../http/authcontex';
import './common.css';
import './style.css';
import { FaTicketSimple } from 'react-icons/fa6';

export default function SideNave({ isSidebarOpen }) {
    const { userEmail } = useAuth();
    const { userRoles } = useAuth();
    const [isCandidateOpen, setIsCandidateOpen] = useState(false);

    const toggleCandidateMenu = () => {
        setIsCandidateOpen((prev) => !prev);
    };

    return (
        <div className={`SideNave ${isSidebarOpen ? 'sb-sidenav-toggled' : ''}`}>
            <div id="layoutSidenav">
                <div id="layoutSidenav_nav">
                    <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div className="sb-sidenav-menu">
                            <div className="nav">
                                <div className="sb-sidenav-menu-heading">
                                    <span>Core</span>
                                </div>
                                <Link className="nav-link" to="/dashboard">
                                    <div className="sb-nav-link-icon">
                                        <FaHome />
                                    </div>
                                    <span>Dashboard</span>
                                </Link>
                                <div className="sb-sidenav-menu-heading">
                                    <span>Activity</span>
                                </div>
                                <button
                                    className="nav-link collapsed"
                                    onClick={toggleCandidateMenu}
                                    aria-expanded={isCandidateOpen}
                                    aria-controls="collapseLayouts"
                                >
                                    <div className="sb-nav-link-icon">
                                        <FaAddressBook />
                                    </div>
                                    <span>Enroll Candidate</span>
                                    <div className="sb-sidenav-collapse-arrow">
                                        <FaCaretDown />
                                    </div>
                                </button>
                                <div
                                    className={`collapse ${isCandidateOpen ? 'show' : ''}`}
                                    id="collapseLayouts"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#sidenavAccordion"
                                >
                                     <nav className="sb-sidenav-menu-nested nav">
                                        <Link className="nav-link" to="/enroll">
                                            <span>Enroll</span>
                                        </Link>
                                    </nav>
                                    <nav className="sb-sidenav-menu-nested nav">
                                        <Link className="nav-link" to="/search">
                                            <span>Export</span>
                                        </Link>
                                    </nav>  
                                   
                                </div>
                                  <Link className="nav-link" to="/managebatch">
                                    <div className="sb-nav-link-icon">
                                        <FaTicketSimple />
                                    </div>
                                    <span>Manage Batch</span>
                                </Link>
                                {Array.isArray(userRoles) && userRoles.includes('ADMIN') && (
                                    <>
                                        <Link className="nav-link" to="/users">
                                            <div className="sb-nav-link-icon">
                                                <FaUserEdit />
                                            </div>
                                            <span>Users</span>
                                        </Link>
                                        <Link className="nav-link" to="/project">
                                            <div className="sb-nav-link-icon">
                                                <FaFileSignature />
                                            </div>
                                            <span>Projects</span>
                                        </Link>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="sb-sidenav-footer">
                            <div className="small">
                                <span>Logged in as:</span>
                            </div>
                            {userEmail || 'Unknown'}
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    );
}
